/* eslint-disable import/first */
import React from 'react';
import { useLocation } from '@reach/router';

// import { selectCurrentCountry } = Slices.profileSlice;
import { Helmet } from 'react-helmet';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;
import { getCountryURL } from 'spwa-ui-library/esm/utils/helper';

const { selectCurrentCountry } = Slices.profileSlice;

const CanonicalTags = () => {
  const location = useLocation();
  const country = useSelector(selectCurrentCountry);
  const countrySpecific = getCountryURL(country.toLowerCase(), process.env.REACT_APP_ENV);

  let path = location.href;
  if (location.hostname !== 'localhost') {
    path = `https://${countrySpecific}${location.pathname}`;
  }

  return (
    <Helmet>
      <link rel="canonical" href={path} />
    </Helmet>
  );
};

export default CanonicalTags;
